<script setup lang="ts">
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import CostRampupGraph from '@/components/Elements/CostRampupGraph.vue';
import { useShipStore } from '@/stores/shipStore.ts';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const shipStore = useShipStore();

const currentFleetSize = computed(() => {
  return shipStore.ships.size;
});

</script>

<template>
  <StandardCard
    top-padding="0"
    :title="t('government.finances.commandHierarchy.title')"
    :help="t('government.finances.commandHierarchy.help')"
  >
    <div class="p-4">
      <div class="graph-container w-full overflow-hidden" style="height: 280px;">
        <CostRampupGraph
          :current-cost="currentFleetSize"
          :min-cost="250"
          :max-cost="5000"
          :steps="25"
        />
      </div>
    </div>
  </StandardCard>
</template>

<style scoped lang="scss">

</style>